import { Edit } from "react-admin";
import { DiscountTabbedForm } from "./DiscountTabbedForm";

export const DiscountEdit = (props) => (
  <Edit title="Edição de Desconto" {...props}>
    <DiscountTabbedForm {...props} />
  </Edit>
);
